import { call, put, select, all } from 'redux-saga/effects';
import * as actions from './actions';
import axios from 'axios';

// the actual http calls
const getCommunicationApiRoot = (tenantId, businessContextId) =>
  `${(window._env_ && window._env_.REACT_APP_USER_API_ROOT) ||
    process.env.REACT_APP_USER_API_ROOT ||
    ''}/communication-service/messagehistory/tenants/${tenantId}/context/${businessContextId}`;

export const getSummary = (
  tenantId,
  businessContextId,
  campaignId,
  fromDate,
  toDate
) =>
  axios
    .get(
      `${getCommunicationApiRoot(tenantId, businessContextId)}/getCostSummary`,
      {
        params: {
          campaignId,
          fromDate,
          toDate
        }
      }
    )
    .then(response => ({
      ...response.data,
      campaignId
    }))
    .catch(err => {
      throw err;
    });
export const getMessageTotal = (
  tenantId,
  businessContextId,
  campaignId,
  campaignType,
  fromDate,
  toDate
) =>
  axios
    .get(`${getCommunicationApiRoot(tenantId, businessContextId)}/search`, {
      params: {
        campaignId,
        fromDate,
        toDate,
        type: campaignType,
        index: 0,
        pageSize: 1
      }
    })
    .then(response => ({
      campaignId,
      totalRecords: parseInt(response.headers['x-ag-totalcount'])
    }))
    .catch(err => {
      throw err;
    });

// sagas

// selectors
const currentCommunication = store => store.communication;
const campaignList = store => store.campaign.list;
const currentTenant = store => store.user.selectedTenant.tenantId;
const currentBusinessContext = store =>
  store.user.selectedBusinessContext.businessContextId;

// TODO: move this into a helper and update campaign and template sagas to use the new helper.
// helper saga to prevent culling the saga tree on rejection of a parallelized task.
function* reflect(callArgs) {
  try {
    return { value: yield call(...callArgs), status: 'resolved' };
  } catch (ex) {
    return ex;
  }
}

export function* getCommunicationsSummaryIfNeeded(action) {
  try {
    const tenantId = yield select(currentTenant);
    const businessContextId = yield select(currentBusinessContext);
    const campaigns = yield select(campaignList);
    const communication = yield select(currentCommunication);
    const newCommunication = {
      tenantId,
      businessContextId,
      data: []
    };
    if (campaigns.length <= 0) {
      yield put(
        actions.gettingCommunicationDataFailed({
          message:
            'Missing Campaigns List - Campaigns must be fetched before communication data can be retrieved.'
        })
      );
      return;
    }
    if (
      communication.tenantId !== tenantId ||
      communication.businessContextId !== businessContextId
    ) {
      const campaignSummaries = yield all(
        campaigns
          .map(campaign => [
            getSummary,
            tenantId,
            businessContextId,
            campaign.id,
            campaign.startDate,
            campaign.endDate
          ])
          .map(reflect)
      );
      const campaignMessageTotals = yield all(
        campaigns
          .map(campaign => [
            getMessageTotal,
            tenantId,
            businessContextId,
            campaign.id,
            campaign.type,
            campaign.startDate,
            campaign.endDate
          ])
          .map(reflect)
      );
      newCommunication.data = campaignMessageTotals.map(messageTotal => {
        let summary = campaignSummaries.find(
          s => s.value.campaignId === messageTotal.value.campaignId
        ).value || { summaries: [] };
        const totalSuccess =
          summary.summaries.length > 0
            ? summary.summaries.reduce((p, c) => p + c.count, 0)
            : undefined;
        const totalCost =
          summary.summaries.length > 0
            ? summary.summaries.reduce((p, c) => p + c.totalCost, 0)
            : undefined;
        const successRatePercent = totalSuccess
          ? Math.floor((totalSuccess / messageTotal.value.totalRecords) * 100)
          : undefined;
        const campaign = campaigns.find(
          c => c.id === messageTotal.value.campaignId
        );
        return {
          ...messageTotal.value,
          tenantId,
          businessContextId,
          totalSuccess,
          totalCost,
          successRatePercent,
          campaign
        };
      });
    } else {
      // not needed - return current state.
      yield put(actions.gettingCommunicationDataSucceeded(communication));
      return;
    }
    // needed - return new communication data.
    yield put(actions.gettingCommunicationDataSucceeded(newCommunication));
  } catch (ex) {
    yield put(actions.gettingCommunicationDataFailed(ex));
  }
}
